import React from 'react';
import { getViewModuleTrackingAttributes } from 'helpers/tracking.helpers';
import { useSeenModulePixel } from 'hook/helper.hook';
import { BUILDER_2_UNENROLLED_OVERVIEW } from 'types/morph.pagePosition.constants';
import SesameCashEnrollModuleView from './SesameCashEnrollModuleView';

const SesameCashCb20UpsellModuleController = props => {
  let trackingAttr = {
    moduleName: props?.module_name
      ? props?.module_name
      : BUILDER_2_UNENROLLED_OVERVIEW,
  };
  if (props?.modulePosition) {
    trackingAttr['modulePosition'] = props?.modulePosition;
  }
  const atr = getViewModuleTrackingAttributes({ ...trackingAttr });

  const seenPixel = useSeenModulePixel(atr);

  return (
    <>
      {seenPixel}
      <SesameCashEnrollModuleView
        copyConfig={props?.copyConfig}
        onLearnMore={props?.onCtaClick}
        isImageColumn={props?.isImageColumn}
        imagePath={props?.imagePath}
      />
    </>
  );
};

export default SesameCashCb20UpsellModuleController;
